// extracted by mini-css-extract-plugin
module.exports = {"modal-form":"ModalForm_modal-form__7_UB2"};